import { render, staticRenderFns } from "./shopping-list.vue?vue&type=template&id=2a2b14cc&"
import script from "./shopping-list.vue?vue&type=script&lang=js&"
export * from "./shopping-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports